import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { EventType, type AuthenticationResult } from '@azure/msal-browser';
import { App } from './App';
import { msalInstance } from './auth';
import './styles.css';

/**
 * MSAL moet geïnitialiseerd zijn en de redirect verwerkt hebben voordat React
 * mag renderen; anders ziet de app zichzelf na het inloggen alsnog als uitgelogd.
 */
async function bootstrap(): Promise<void> {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(accounts[0]!);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
    }
  });

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>
  );
}

bootstrap().catch((error: unknown) => {
  // Zonder werkende MSAL is er geen portaal; laat dan iets leesbaars zien in
  // plaats van een witte pagina.
  const root = document.getElementById('root');
  if (root) {
    root.textContent = `Het portaal kon niet starten: ${
      error instanceof Error ? error.message : String(error)
    }`;
    root.setAttribute('style', 'padding:32px;font-family:system-ui');
  }
  console.error('[portaal] starten mislukt', error);
});
